import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/quotes/extra-reducers';
import reducers from 'src/redux/quotes/reducers';

import { quoteInitialState } from './types';

const quotesSlice = createSlice({
  name: 'quotes',
  initialState: quoteInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  setGroupedDataMetaLoading,
  clearQuoteData,
  updateQuoteAssigneeDetails,
  updateQuoteCategoryDetails,
  updateQuoteDetailsPropertyAddress,
  updateQuotesDataByGroupOptions,
  updateQuotesTags,
  addToQuoteListOrReorderTheList,
  shouldSidePanel,
  removeQuoteIdFromList,
} = quotesSlice.actions;

export default quotesSlice.reducer;
